<template>
  <MetricCard
    apiEndpoint="/google-search-console/clicks"
    metricName="CLICKS"
    :formatData="formatClicks"
    srcName="Google Search Console"
  />
</template>

<script setup>
import { formatNumber } from '@/utils/helperFunctions';
import MetricCard from '@/components/MetricCard.vue';

const formatClicks = (data) => formatNumber(data.data);
</script>
